<script setup>
import { ref } from 'vue'
import SubtopicIndicatorsModal from "@/components/about/overview/SubtopicIndicatorsModal.vue";

//properties set by parent
const props = defineProps({
	topic: {
		type: Object,
		required: true,
	},	
	subtopic: {
		type: Object,
		required: true,
	}
})


//reactive field proxies
const openIndModal = ref(false)
const topic = ref(props.topic)
const subtopic = ref(props.subtopic)

//console.log('st', subtopic.value)
//binding to invoke method on child componenet
//const childRefIndModal = ref({})

//methods
/* function openIndicatorsModal() {
	openIndModal.value = true
	//childRefIndModal.value.openModal()
} */

/* function closeSubtopicIndicatorsModal() {
	openIndModal.value = false
} */


</script>

<template>
	<article class="card">		
		<div class="title">
			{{props.subtopic.title}}
		</div>
		<div class="description">
			{{props.subtopic.description}}
		</div>	
		<ul>
			<li v-for="(indicator, index) in props.subtopic.indicators" :key="index">
				<div v-if="props.subtopic.indicators.length < 5 || index < 3">
					<router-link class="card-item" :to="{ name: 'ExplorerView', query: {iname: `${encodeURIComponent(indicator.name)}`}}">{{indicator.name}}</router-link>
				</div>
				<div v-else-if="index == 3">
					<button class="btn-tertiary" @click="openIndModal = true">See Full List</button>
				</div>

				<!-- 			<a
				:href=""
				:class="{ active: activeId == section.id && section.id > 0}">
				<span :class="{ title: section.id == '0'}">{{ section.anchor }}</span>
			</a> -->
			</li>
		</ul>
	</article>
	<SubtopicIndicatorsModal :isOpen="openIndModal"  :topic="topic" :subtopic="subtopic"  @closeIndModal="openIndModal = false" />
</template>

<style scoped>
.card {
	display: flex;
	flex-direction: column;
	width: 20.4375rem;
	height: 25rem;
	padding: 1.5rem 1.25rem;
	margin-top: 1rem;
	align-items: start;
	gap: 0.625rem;

	border-radius: var(--radius-xl);
	background: var(--surface-color-Secondary);
	box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.10);
}

.title {
	/* Regular/H5 */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-H6);
	font-style: normal;
	font-weight: 500;
	line-height: var(--font-line-height-H6);
}

.icon {
	color: var(--icon-cta-Blue);
}

.description {
	color: var(--text-Primary);
	font-variant-numeric: lining-nums proportional-nums;
	font-feature-settings: 'liga' off, 'clig' off;
	text-overflow: ellipsis;

	/* Regular/Base */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base);
	font-style: normal;
	font-weight: 400;
	line-height: var(--font-line-height-Base);
}

ul {
	padding: 0;
}

li {
	list-style-type: none;
	padding: 4px 0;
}

a {
	text-decoration: none;
	color: var(--text-Link);
}

.card-link {
	font-family: var(--font-family-title, Roboto);
	font-size: var(--font-size-Base, 16px);
	font-style: normal;
	font-weight: 400;
	line-height: var(--font-line-height-Base, 24px);
}

.btn-tertiary {
	padding: 0;
	color: var(--text-Link);
	height: unset;
}

.btn-tertiary:hover {
	text-decoration: none;
}

</style>